import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getUsers(config = {}) {
    return axiosInstance.get('/master/user', { ...config, cancelToken: getNewCancelToken() });
  },
  create(data, config = {}) {
    return axiosInstance.post('/master/user', data, { ...config, cancelToken: getNewCancelToken() });
  },
  update(id, data, config = {}) {
    return axiosInstance.put(`/master/user/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  delete(id, config = {}) {
    return axiosInstance.delete(`/master/user/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  addUserCompany(data, config = {}) {
    return axiosInstance.post('/master/user_company', data, { ...config, cancelToken: getNewCancelToken() });
  },
  getUserCompany(config = {}) {
    return axiosInstance.get('/master/user_company', { ...config, cancelToken: getNewCancelToken() });
  },
  deleteUserCompany(id, config = {}) {
    return axiosInstance.delete(`/master/user_company/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getUserRoles(param, config = {}) {
    return axiosInstance.get('/master/user_role', { params: { page: param }, ...config, cancelToken: getNewCancelToken() });
  },
  getUserRoleById(param, config = {}) {
    return axiosInstance.get(`/master/user_role?findField=${param.findField}&findValue=${param.findValue}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getUserRoleByUserId(userId, config = {}) {
    return axiosInstance.get('/master/user_role', {
      params: { 'finds[usroUserId]': userId },
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  deleteUserRoleById(id, config = {}) {
    return axiosInstance.delete(`/master/user_role/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  addUserRole(data, config = {}) {
    return axiosInstance.post('/master/user_role', data, { ...config, cancelToken: getNewCancelToken() });
  },
  updateUserRole(data, id, config = {}) {
    return axiosInstance.put(`/master/user_role/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  deleteUserRole(id, config = {}) {
    return axiosInstance.delete(`/master/user_role/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getRoles(config = {}) {
    return axiosInstance.get('/master/roles', { ...config, cancelToken: getNewCancelToken() });
  },
  getRoleByName(data, config = {}) {
    return axiosInstance.get('/master/roles', { params: data, ...config, cancelToken: getNewCancelToken() });
  },
  addRole(data, config = {}) {
    return axiosInstance.post('/master/roles', data, { ...config, cancelToken: getNewCancelToken() });
  },
  updateRole(data, id, config = {}) {
    return axiosInstance.put(`/master/roles/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  deleteRole(id, config = {}) {
    return axiosInstance.delete(`/master/roles/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getRolePermissions(param, config = {}) {
    return axiosInstance.get('/master/role_permission', { params: { page: param }, ...config, cancelToken: getNewCancelToken() });
  },
  getRolePermissionByRoleId(param, config = {}) {
    return axiosInstance.get('/master/role_permission', { params: param, ...config, cancelToken: getNewCancelToken() });
  },
  addRolePermission(data, config = {}) {
    return axiosInstance.post('/master/role_permission', data, { ...config, cancelToken: getNewCancelToken() });
  },
  updateRolePermission(data, id, config = {}) {
    return axiosInstance.put(`/master/role_permission/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  deleteRolePermission(id, config = {}) {
    return axiosInstance.delete(`/master/role_permission/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getPermissions(param, config = {}) {
    return axiosInstance.get('/master/permission', { params: { page: param, max: 200 }, ...config, cancelToken: getNewCancelToken() });
  },
  getPermissionsByName(param, config = {}) {
    return axiosInstance.get(`/master/permission?findField=${param.findField}&findValue=${param.findValue}`, { ...config, cancelToken: getNewCancelToken() });
  },
  addPermission(data, config = {}) {
    return axiosInstance.post('/master/permission', data, { ...config, cancelToken: getNewCancelToken() });
  },
  updatePermission(data, id, config = {}) {
    return axiosInstance.put(`/master/permission/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  deletePermission(id, config = {}) {
    return axiosInstance.delete(`/master/permission/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getUserRolePermissions(param, config = {}) {
    return axiosInstance.get('/master/role_permission', { params: param, ...config, cancelToken: getNewCancelToken() });
  },
  getUserLogin(config = {}) {
    return axiosInstance.get('/master/user_login', { ...config, cancelToken: getNewCancelToken() });
  },
  updateUserLogin(id, data, config = {}) {
    return axiosInstance.put(`/master/user_login/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  createUserLogin(data, config = {}) {
    return axiosInstance.post('/master/user_login', data, { ...config, cancelToken: getNewCancelToken() });
  },
  deleteUserLogin(id, config = {}) {
    return axiosInstance.delete(`/master/user_login/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getUserAssets(config = {}) {
    return axiosInstance.get('/master/user_asset', { ...config, cancelToken: getNewCancelToken() });
  },
  updateUserAsset(id, data, config = {}) {
    return axiosInstance.put(`/master/user_asset/${id}`, data, { ...config, cancelToken: getNewCancelToken() });
  },
  createUserAsset(data, config = {}) {
    return axiosInstance.post('/master/user_asset', data, { ...config, cancelToken: getNewCancelToken() });
  },
  deleteUserAsset(id, config = {}) {
    return axiosInstance.delete(`/master/user_asset/${id}`, { ...config, cancelToken: getNewCancelToken() });
  },
  getAssetByName(param, config = {}) {
    return axiosInstance.get(`/master/asset?findField=${param.findField}&findValue=${param.findValue}`, { ...config, cancelToken: getNewCancelToken() });
  },
};
